import React, { useRef } from 'react';

import ModalDirectors from './ModalDirectors';

import MariaBg from '../../../../../Images/modals/directors/maria/bg_maria.png';
import Video1 from '../../../../../Images/modals/directors/maria/video-1.png';
import Video2 from '../../../../../Images/modals/directors/maria/video-2.png';
import Video3 from '../../../../../Images/modals/directors/maria/video-3.png';
import Video4 from '../../../../../Images/modals/directors/maria/video-4.png';

import {
  Director_Maria,
  Text_Maria,
  TextVideo1_Maria,
  TextVideo2_Maria,
  TextVideo3_Maria,
  TextVideo4_Maria,
} from '../../../../../utils/EN/Modals/directors';

const ModalMaria = () => {
  return (
    <>
      <ModalDirectors
        id="director-maria"
        mainBg={MariaBg}
        directorName={Director_Maria}
        mainVideoBg={Video1}
        videoText1={TextVideo1_Maria}
        mainVideoLink={'maria-video-1'}
        directorText={Text_Maria}
        rowImage1={Video2}
        videoText2={TextVideo2_Maria}
        rowVideoLink1={'maria-video-2'}
        rowImage2={Video3}
        videoText3={TextVideo3_Maria}
        rowVideoLink2={'maria-video-3'}
        rowImage3={Video4}
        videoText4={TextVideo4_Maria}
        rowVideoLink3={'maria-video-4'}
      />
    </>
  );
};

export default ModalMaria;
